import { formatRut, formatToDdMmYyyy } from '@/utils';
import type {
  LC_GetShiftAssignmentsListOut,
  LC_ShiftAssignmentItem,
  ShiftAssignmentListItem,
  ShiftAssignmentListResult,
} from './shiftAssignment.types';


const mapShiftAssignmentListItem = (
  dto: LC_ShiftAssignmentItem,
): ShiftAssignmentListItem => ({
  id: dto.id,
  employeeId: dto.employeeId,
  employeeTaxIdentificationNumber: formatRut(dto.employeeTaxIdentificationNumber ?? ''),
  employeeName: dto.employeeName ?? '',
  shiftId: dto.shiftId,
  shiftName: dto.shiftName ?? '',
  startDate: formatToDdMmYyyy(dto.startDate),
  // An assignment without an end date is left empty here on purpose: the column decides
  // the label ("Indefinido") so the wording stays in i18n and out of the mapper.
  endDate: dto.endDate ? formatToDdMmYyyy(dto.endDate) : '',
  assignedAt: formatToDdMmYyyy(dto.assignedAt),
  assignedBy: dto.assignedBy ?? '',
  status: dto.status ?? '',
});

/**
 * Maps the shift assignment history paginated response (ASIS-5656) to the UI model.
 */
export const mapShiftAssignmentList = (
  out: LC_GetShiftAssignmentsListOut,
): ShiftAssignmentListResult => ({
  items: out.data?.map(mapShiftAssignmentListItem) ?? [],
  totalRecords: out.pagination?.totalRecords ?? 0,
});
